import * as React from "react";
import { ParallaxProvider, ParallaxBanner } from "react-scroll-parallax";
import { centered } from "./hero.module.scss";
import { narrowScreen } from "./../../assets/scss/variables.module.scss";
import "./../../style.scss";
import IDMCLogo from "./../../images/IDMC_logo_white.svg";
import NRCLogo from "./../../images/nrc-image.png";
import { Container } from "@mui/material";
import { Facebook, Twitter, Instagram, YouTube } from "@mui/icons-material";

/**
 * Component Name: Hero
 * Description: Parallax banner based on react-scroll-parallax
 *
 * Prop list:
 * imageUrl => url of background image
 * id => Unique id of the section
 * bgColor => color of overlay - do not use for no overlay
 * bgOpacity => opacity of overlay - do not use if no overlay
 * txtColor => color of text inside (children)
 *
 * Accepts children for text inside banner
 *
 */

const Footer = ({
  id,
  imageUrl,
  size,
  bgColor,
  bgOpacity,
  txtColor,
  children,
}) => {
  const bannerHeightHalf = {
    minHeight: "300px",
    height: "50vh",
  };

  const bannerBody = {
    maxWidth: narrowScreen,
    margin: "auto",
  };
  const overlay = {
    width: "100%",
    height: "100%",
    backgroundColor: bgColor,
    opacity: bgOpacity ? bgOpacity : "0",
  };
  const textColor = {
    color: txtColor ? txtColor : "#000000",
  };
  const posAbs = {
    position: "absolute",
    bottom: "20px",
    right: "20px",
  };

  return (
    <ParallaxProvider>
      <ParallaxBanner
        id="footer"
        layers={[
          {
            image: `${imageUrl}`,
            speed: -20,
            children: <div style={overlay}>Overlay</div>,
          },
          {
            speed: 0,
            children: (
              <Container maxWidth="lg" style={{ textColor }}>
                <div
                  className="mt-5"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <div className='row mt-3'> */}
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            {/* <StaticImage
                      placeholder='none'
                      src='./../../images/IDMC_logo_white.svg'
                      alt='IDMC logo'
                      layout='constrained'
                      height={30}
                    /> */}
                            <img src={IDMCLogo} height="30" />
                          </div>
                          <div>
                            {/* <StaticImage
                      placeholder='none'
                      src='./../../images/nrc-image.png'
                      alt='NRC logo'
                      layout='constrained'
                      height={45}
                    /> */}
                            <img src={NRCLogo} height="45" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <h2 style={{ fontSize: "1.7em" }}>Contact</h2>
                        <p>
                          Centre de surveillance des déplacements internes
                          (IDMC)
                        </p>
                        <p>
                        Humanitarian Hub Office, La Voie Creuse 16, 1202 Geneva<br />
                          Renseignements généraux :{" "}
                          <a href="mailto:info@idmc.ch">info@idmc.ch</a> <br />
                          Demandes de renseignements des médias :{" "}
                          <a href="mailto:media@idmc.ch">media@idmc.ch</a>
                        </p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <h2 style={{ fontSize: "1.7em" }}>À propos de nous</h2>
                        <p>
                          Le Rapport mondial de l’IDMC sur le déplacement
                          interne (GRID) est la principale source mondiale de
                          données et d’analyses sur le sujet. Depuis notre
                          création en 1998 dans le cadre du Conseil norvégien
                          pour les réfugiés (NRC), nous proposons un service
                          rigoureux, indépendant et fiable à la communauté.
                          Notre travail éclaire des décisions stratégiques et
                          opérationnelles qui améliorent la vie des millions de
                          personnes vivant en situation de déplacement interne
                          ou risquant de l’être à l’avenir.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          Copyright © Centre de surveillance des déplacements
                          internes (IDMC). Sauf indication contraire, tous les
                          documents de cette page peuvent être partagés
                          librement à condition de mentionner l’IDMC, dans la
                          mesure où la source est incluse. Les documents ne
                          peuvent être adaptés sans l’autorisation de l’IDMC.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <a href="https://www.facebook.com/IDMC.Geneva">
                          <Facebook sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="http://twitter.com/IDMC_Geneva">
                          <Twitter sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="http://www.linkedin.com/company/internal-displacement-monitoring-centre-idmc-">
                          <Instagram sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="https://www.youtube.com/channel/UCKEgRCcKKPNezkF3FLlfBRQ">
                          <YouTube sx={{ color: "#ffffff" }} />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </Container>
            ),
          },
        ]}
        className=" footerHeight "
      ></ParallaxBanner>
    </ParallaxProvider>
  );
};

export default Footer;
